import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  token: string | null = null;
  password: string = '';
  confirmPassword: string = '';
  validationError: string | null = null;
  passwordError: string | null = null;
  confirmPasswordError: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute, private authService: AuthService) { }

   ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
  }

  validatePassword() {
    if (!this.password) {
      this.passwordError = 'New Password is required.';
    } else if (this.password.length < 8) {
      this.passwordError = 'Password must be at least 8 chars with letters & numbers';
    } else {
      this.passwordError = null;
    }
  }


  validateConfirmPassword() {
    this.confirmPasswordError = !this.confirmPassword ? 'Confirm Password is required.' : null;
    if (this.password && this.confirmPassword && this.password !== this.confirmPassword) {
      this.validationError = 'Passwords do not match.';
    } else {
      this.validationError = null;
    }
  }

 onSubmit(): void {
  // Reset previous errors
  this.passwordError = null;
  this.confirmPasswordError = null;
  this.validationError = null;

  // Validate New Password
  if (!this.password) {
    this.passwordError = 'New Password is required.';
  } else if (this.password.length < 8) {
    this.passwordError = 'Password must be at least 8 chars with letters & numbers';
  }

  // Validate Confirm Password
  if (!this.confirmPassword) {
    this.confirmPasswordError = 'Confirm Password is required.';
  }

  // Validate password match
  if (this.password && this.confirmPassword && this.password !== this.confirmPassword) {
    this.validationError = 'Passwords do not match.';
  }

  // ✅ Prevent API call if invalid
  if (this.passwordError || this.confirmPasswordError || this.validationError) {
    return;
  }

  // ✅ Safe API call
  const queryParams = { token: this.token };

  this.authService
    .resetPassword({ password: this.password }, queryParams)
    .pipe(untilDestroyed(this))
    .subscribe({
      next: () => {
        sweetAlert('Success', 'Password Reset successfully!', 'success', 'OK');
         this.router.navigateByUrl('/login')
      },
      error: (err) => {
        sweetAlert('Error', err, 'error', 'Ok');
      }
    });
}

}
